// removed by extract-text-webpack-plugin
module.exports = {"selected":"state__selected___flEDM bg-white borderColor-positive","disabled":"state__disabled___2XJlM opacity-40","dragging":"state__dragging___1RJvb bg-white position-relative","multiple":"state__multiple___310QG position-relative bg-white"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-card/Card/style/state.css
// module id = 140
// module chunks = 0 1